import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteDebugger: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('🛣️ Route changed:', {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: location.state,
      timestamp: new Date().toISOString()
    });

    if (location.pathname === '/') {
      console.log('🏠 User on landing page - this may be intentional or a redirect');
      const stackTrace = new Error().stack;
      if (stackTrace) {
        console.log('📍 Navigation stack trace:', stackTrace);
      }
    }
  }, [location]);

  return null;
};

export default RouteDebugger;
